/**
 * Sentry filters for errors the app cannot fix: they come from ad scripts,
 * browser extensions, the browser itself or the user's network.
 */

// Matched against the error message; strings match anywhere in it
export const ignoreErrors = [
  'Network Error',
  'No error message',
  // AdSense RUM script
  /^int64$/,
  // Benign browser layout warning
  /^ResizeObserver loop/,
  // Safari extensions
  'Invalid call to runtime.sendMessage()',
  // In-app browsers on iOS
  'WKWebView API client did not respond',
  // Firebase Auth: user's network, a second sign-in popup, gapi blocked
  'A network error (such as timeout, interrupted connection or unreachable host) has occurred',
  'This operation has been cancelled due to another conflicting popup',
  'gapi.iframes.getContext',
];

// Matched against the URL of the script that threw the error
export const denyUrls = [
  // Google ad scripts
  /\/pagead\//,
  /googlesyndication\.com/,
  // Browser extensions; Safari masks extension script URLs
  /^(chrome|moz|safari|safari-web)-extension:\/\//,
  /^webkit-masked-url:/,
];
